import { useEffect } from 'react';

// Logout flow:
// 1. Call backend /app/logout to revoke refresh token + clear cookies
// 2. Backend redirects to FA /oauth2/logout which kills the FA session
// 3. FA redirects back to the post-logout redirect (login page)

const LogoutPage = () => {
  useEffect(() => {
    // Redirect to backend logout endpoint — it handles everything
    window.location.href = '/app/logout';
  }, []);

  return (
    <div>
      <h2>Logging out...</h2>
    </div>
  );
};

export default LogoutPage;
